import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

export default function Reservation() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 300 });

  const costItems = [
    { label: '在庫リスク', amount: '¥12,870' },
    { label: '店舗マージン', amount: '¥19,305' },
    { label: '広告費', amount: '¥5,500' },
    { label: '物流コスト', amount: '¥1,375' },
  ];

  return (
    <section
      ref={ref}
      className={`py-16 md:py-40 px-5 md:px-10 bg-[#f5f5f7] transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
    >
      <div className="max-w-4xl mx-auto">

        {/* セクションラベル */}
        <div className="text-center mb-10 md:mb-20">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-4 md:mb-6">Why Pre-order</p>
          <h2 className="text-2xl md:text-6xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight tracking-tight">
            なぜ30%Offを<br className="md:hidden" />実現できたのか？
          </h2>
          <p className="text-sm md:text-lg text-gray-500 leading-relaxed">
            事前に受注数を確定させることで、4つのコストを削減。<br className="hidden md:block" />
            その差額を、そのままあなたへ還元します。
          </p>
        </div>

        {/* 価格比較 */}
        <div className="text-center mb-14 md:mb-24">
          <div className="flex items-center justify-center gap-6 md:gap-12 mb-6 md:mb-8">
            <div>
              <p className="text-xs md:text-sm text-gray-400 tracking-widest uppercase mb-2">定価</p>
              <p className="text-2xl md:text-5xl font-bold text-gray-400 line-through">¥128,700</p>
            </div>
            <div className="w-10 h-10 md:w-16 md:h-16 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl md:text-4xl text-purple-600"></i>
            </div>
            <div>
              <p className="text-xs md:text-sm text-gray-400 tracking-widest uppercase mb-2">予約価格</p>
              <p className="text-3xl md:text-6xl font-black text-gray-900">¥89,650</p>
            </div>
          </div>
          <div className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-purple-600 text-white rounded-full">
            <span className="text-base md:text-xl font-black">差額 ¥39,050</span>
          </div>
        </div>

        {/* コスト内訳 - シンプルな数字リスト */}
        <div className="max-w-2xl mx-auto mb-14 md:mb-24">
          <div className="space-y-3 md:space-y-5">
            {costItems.map((item) => (
              <div
                key={item.label}
                className="flex items-center justify-between py-3.5 md:py-5 border-b border-gray-300"
              >
                <span className="text-base md:text-xl font-medium text-gray-900">{item.label}</span>
                <span className="text-lg md:text-2xl font-bold text-gray-900">{item.amount}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4 md:gap-5">
          <a
            href="https://mever.design/products/mever-chair-pro-ver2"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full md:max-w-md mx-auto px-8 md:px-12 py-5 md:py-6 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white text-lg md:text-2xl font-bold rounded-full transition-all duration-300 shadow-2xl hover:shadow-purple-500/30 transform hover:scale-105 active:scale-[0.97] whitespace-nowrap cursor-pointer text-center min-h-[56px] flex items-center justify-center"
          >
            今すぐ予約する →
          </a>
          <div className="flex items-center gap-3 flex-wrap justify-center">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white text-xs font-bold tracking-widest rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-pulse"></span>
              各色50脚限定
            </span>
            <span className="text-gray-400">／</span>
            <span className="text-xs text-gray-500">ブラック・グレー</span>
          </div>
        </div>

      </div>
    </section>
  );
}